export const GET_TOKEN_BALANCE = 'GET_TOKEN_BALANCE';
export const GET_TOKEN_BALANCE_SUCCESS = 'GET_TOKEN_BALANCE_SUCCESS';
export const GET_TOKEN_BALANCE_FAIL = 'GET_TOKEN_BALANCE_FAIL';

export const GET_TOKEN_PACKAGES = 'GET_TOKEN_PACKAGES';
export const GET_TOKEN_PACKAGES_SUCCESS = 'GET_TOKEN_PACKAGES_SUCCESS';
export const GET_TOKEN_PACKAGES_FAIL = 'GET_TOKEN_PACKAGES_FAIL';

export const PURCHASE_TOKENS = 'PURCHASE_TOKENS';
export const PURCHASE_TOKENS_SUCCESS = 'PURCHASE_TOKENS_SUCCESS';
export const PURCHASE_TOKENS_FAIL = 'PURCHASE_TOKENS_FAIL';

export const CONSUME_TOKENS = 'CONSUME_TOKENS';
export const CONSUME_TOKENS_SUCCESS = 'CONSUME_TOKENS_SUCCESS';
export const CONSUME_TOKENS_FAIL = 'CONSUME_TOKENS_FAIL';

export const GET_TOKEN_COUNTDOWN = 'GET_TOKEN_COUNTDOWN';
export const GET_TOKEN_COUNTDOWN_SUCCESS = 'GET_TOKEN_COUNTDOWN_SUCCESS';
export const GET_TOKEN_COUNTDOWN_FAIL = 'GET_TOKEN_COUNTDOWN_FAIL';

// Action types are now handled by createAction from redux-act
// No need for manual interface definitions

export const types = {
    GET_TOKEN_BALANCE,
    GET_TOKEN_BALANCE_SUCCESS,
    GET_TOKEN_BALANCE_FAIL,
    GET_TOKEN_PACKAGES,
    GET_TOKEN_PACKAGES_SUCCESS,
    GET_TOKEN_PACKAGES_FAIL,
    PURCHASE_TOKENS,
    PURCHASE_TOKENS_SUCCESS,
    PURCHASE_TOKENS_FAIL,
    CONSUME_TOKENS,
    CONSUME_TOKENS_SUCCESS,
    CONSUME_TOKENS_FAIL,
    GET_TOKEN_COUNTDOWN,
    GET_TOKEN_COUNTDOWN_SUCCESS,
    GET_TOKEN_COUNTDOWN_FAIL,
};
